module.exports = __webpack_public_path__ + "static/media/7.b670be24.jpg";